import { timeInKitchen } from './kitchenTime';
import type { HomeTask } from './tasks';
import { roomName } from '../../libs';
import type { Kitchen } from '../../libs';
import { formatQuantity } from '../BatchTracking/format';
import { strings } from '../BatchTracking/strings';
import type { Batch } from '../BatchTracking/types';

export type TaskDescription = {
  title: string;
  details: string[];
  note?: string;
};

export const describeVideoReview = (task: HomeTask, kitchen: Kitchen): TaskDescription => {
  const review = task.videoReview;
  const people = review === undefined ? '' : ` · ${review.peopleCount} ${review.peopleCount === 1 ? 'person' : 'people'}`;
  return {
    title: review?.room ? roomName(review.room) : task.title,
    details: [`Recorded ${timeInKitchen(task.startsAt, kitchen)}${people}`],
    note: review?.newAnswerFromYourNotes ? 'New answer from your notes' : undefined
  };
};

export const describeProductionPlan = (task: HomeTask, kitchen: Kitchen): TaskDescription => {
  const plan = task.productionPlan;
  const span = [task.startsAt, task.endsAt].filter((iso) => iso !== undefined).map((iso) => timeInKitchen(iso, kitchen));
  const quantity = plan?.quantity === undefined ? undefined : [plan.quantity, plan.unit].filter(Boolean).join(' ');
  const item = [plan?.itemName ?? plan?.itemId, quantity].filter(Boolean).join(' · ');
  return {
    title: task.title,
    details: [
      plan?.locationId === undefined ? '' : roomName(plan.locationId),
      item,
      span.join('–'),
      plan?.readyBy === undefined ? '' : `Ready by ${timeInKitchen(plan.readyBy, kitchen)}`
    ].filter(Boolean)
  };
};

export const describeBatch = (batch: Batch): TaskDescription => ({
  title: batch.itemName,
  details: [
    formatQuantity(batch.quantity, batch.unit),
    batch.childCount > 0 ? strings.batches.childCount(batch.childCount) : ''
  ].filter(Boolean)
});
